export default function NewsLetter() {
  return (<></>);
}
